import React from 'react';
import ReactDOM from 'react-dom';
import { IntlProvider, addLocaleData } from 'react-intl';
import serverVars from 'server-vars';
import chatUtils from 'dibs-buyer-layout/src/utils/chat';
import { initializeDBL } from 'dibs-buyer-layout/src/entries/index';

import { TradeSourcingContainer } from '../sourcing/TradeSourcingContainer';

import '../sourcing/trade-sourcing.scss';

const locale = serverVars.get('localeDataKey');
const messages = serverVars.get('messages');

initializeDBL().then(() => {
    if (window.ReactIntlLocaleData) {
        addLocaleData(window.ReactIntlLocaleData[locale]);
    }

    const TradeSourcing = React.createElement(TradeSourcingContainer, {
        showChatUtils: chatUtils.show.bind(chatUtils),
    });

    ReactDOM.render(
        React.createElement(IntlProvider, { locale, messages }, TradeSourcing),
        document.getElementById('tradeSourcingContainer')
    );
});
